<template>
  <basic-container>
    <div class="search">
      <el-form ref="routeQueryForm" :model="routeQueryForm" :inline="true" size="mini">
        <el-form-item label="线路名称" prop="routeName">
          <el-input v-model="routeQueryForm.routeName" clearable placeholder="请输入内容" />
        </el-form-item>
        <el-form-item label="出发城市" prop="startCityId">
          <el-select
            v-model="startAreaManageName"
            filterable
            clearable
            :filter-method="filterRegionData"
            placeholder="请选择"
            @focus="resetStartAreaManager"
          >
            <el-option :value="routeQueryForm.startAreaManageId" style="height: auto">
              <el-tree
                class="filter-tree"
                :props="regionProps"
                :data="startAreaTreeData"
                :filter-node-method="filterRegionTreeNode"
                ref="startAreaManagerTree"
                @node-click="handleNodeClick"
              />
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="目的城市" prop="endCityId">
          <el-select
            v-model="endAreaManageName"
            filterable
            clearable
            :filter-method="filterEndRegionData"
            placeholder="请选择"
            @focus="resetEndAreaManager"
          >
            <el-option :value="routeQueryForm.endAreaManageId" style="height: auto">
              <el-tree
                class="filter-tree"
                :props="regionProps"
                :data="endAreaTreeData"
                :filter-node-method="filterEndRegionTreeNode"
                ref="endAreaManagerTree"
                @node-click="handleEndNodeClick"
              />
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出发站点" prop="startStationId">
          <yd-common-selector
            v-model="routeQueryForm.startStationId"
            placeholder="请输入关键字查找线路名称"
            :options="startStationNameList"
          />
        </el-form-item>
        <el-form-item label="目的站点" prop="endStationId">
          <yd-common-selector
            v-model="routeQueryForm.endStationId"
            placeholder="请输入关键字查找线路名称"
            :options="endStationNameList"
          />
        </el-form-item>
        <!--        线路类型（1普通线；2旅游线；3校园线；4接驳线；5机场线-->
        <el-form-item label="线路类型" prop="routeTypeId">
          <yd-common-selector v-model="routeQueryForm.routeTypeId" :options="options" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <yd-common-selector v-model="routeQueryForm.status" :options="stateOptions" />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            :loading="loading"
            @click="getRoteListPage(1)"
            >筛选</el-button
          >
          <el-button type="danger" icon="el-icon-delete" :loading="loading" @click="clearRouteForm"
            >清空</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div>
      <!--    线路列表-->
      <div class="refund-table">
        <yd-table
          :data="routeDataTable"
          :loading="loading"
          :pagination="pages"
          @onChange="onTableChange"
        >
          <template #actions>
            <el-button
              type="primary"
              size="mini"
              @click="jumpUrl('/route')"
              v-has-permi="['transport_route_add']"
              >新增线路</el-button
            >
            <el-button type="primary" size="mini" @click="handleOperateLog">操作日志</el-button>
          </template>
          <el-table-column align="center" prop="id" width="60" label="ID" />
          <el-table-column
            :show-overflow-tooltip="true"
            label="线路名称"
            prop="lineName"
            align="center"
          />
          <el-table-column
            :show-overflow-tooltip="true"
            label="出发城市"
            prop="startCityName"
            align="center"
          />
          <el-table-column
            :show-overflow-tooltip="true"
            label="目的城市"
            prop="endCityName"
            align="center"
          />
          <el-table-column
            :show-overflow-tooltip="true"
            label="出发地址"
            prop="startAddress"
            align="center"
          />
          <el-table-column
            :show-overflow-tooltip="true"
            label="到达地址"
            prop="endAddress"
            align="center"
          />
          <el-table-column
            :show-overflow-tooltip="true"
            label="行程时长"
            prop="durationStr"
            align="center"
          />
          <el-table-column
            :show-overflow-tooltip="true"
            label="总里程数（公里）"
            prop="mileage"
            align="center"
          />
          <el-table-column
            :show-overflow-tooltip="true"
            label="线路类型"
            prop="typeStr"
            align="center"
          />
          <el-table-column :show-overflow-tooltip="true" label="状态" prop="status" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" type="success" v-if="scope.row.status === 1">正常</el-tag>
              <el-tag size="mini" type="info" v-if="scope.row.status === 2">下架</el-tag>
            </template>
          </el-table-column>
          <!--操作栏-->
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <el-row>
                <el-button
                  size="mini"
                  type="text"
                  @click="getRouteInfo(scope.row)"
                  v-has-permi="['transport_route_info']"
                  >详情</el-button
                >
                <el-button
                  size="mini"
                  type="text"
                  @click="editRoute('/route', scope.row)"
                  v-has-permi="['transport_route_edit']"
                  >编辑</el-button
                >
                <el-button
                  size="mini"
                  type="text"
                  v-show="scope.row.status === 1"
                  @click="checkRouteStatus(scope.row)"
                  v-has-permi="['transport_route_dow']"
                  >下架</el-button
                >
                <el-button
                  size="mini"
                  type="text"
                  v-show="scope.row.status === 2"
                  @click="checkRouteStatus(scope.row)"
                  v-has-permi="['transport_route_up']"
                  >上架</el-button
                >
              </el-row>
            </template>
          </el-table-column>
        </yd-table>
      </div>
    </div>
    <!--新增或编辑线路-->
    <route-set-info ref="routeSetInfo" @onUrlChange="jumpUrl" v-if="showDrawerVisible" />
    <OperateLog :visible="operateVisible" :active="'line'" @close="handleClose" />
  </basic-container>
</template>

<script>
  // import routeSetAdd from './routeset-add'
  import routeSetInfo from './routeset-info'
  import {
    getRoteList,
    queryAllCity,
    queryAllFstation,
    changeRouteStatus
  } from '@/api/transport/routeset'
  import { getRegionTree } from '@/api/belong/addressbelong'
  import OperateLog from '@/components/operateLog/oLog'
  import { lineType, state } from './enum.data'
  import { setStore, getStore, removeStore } from '@/util'

  export default {
    name: 'routeSetList',
    components: { routeSetInfo, OperateLog },
    data() {
      return {
        showDrawerVisible: false,
        currentPage: 1,
        eachPage: 10,
        countRoutePages: 0,
        routeQueryForm: {},
        showAddDialog: false,
        routeDataTable: [],
        startCityNameList: [],
        endCityNameList: [],
        startStationNameList: [],
        endStationNameList: [],
        regionProps: {
          id: 'id',
          label: 'areaName',
          children: 'childAreaManage'
        },
        startAreaTreeData: [],
        endAreaTreeData: [],
        startAreaManageName: '',
        endAreaManageName: '',
        operateVisible: false,
        loading: false
      }
    },
    computed: {
      options() {
        return lineType
      },
      stateOptions() {
        return state
      },
      pages() {
        return {
          total: this.countRoutePages,
          current: this.currentPage,
          pageSize: this.eachPage
        }
      }
    },
    watch: {
      startAreaManageName(val) {
        this.$refs.startAreaManagerTree.filter(val)
      },
      endAreaManageName(val) {
        this.$refs.endAreaManagerTree.filter(val)
      }
    },
    mounted() {
      this.getAllStation()
      this.getAllCity()
      this.getAllAddressBelong()
    },
    methods: {
      onTableChange({ current, pageSize }) {
        this.currentPage = current
        this.eachPage = pageSize
        const params = getStore({ name: 'routerSetParams', type: 'session' }) || {}
        this.routeQueryForm = {
          ...this.routeQueryForm,
          ...params
        }
        this.getRoteListPage()
      },
      // 查询线路列表
      getRoteListPage(val) {
        const page = val || this.currentPage
        const linePageDto = {
          page,
          size: this.eachPage,
          startAreaManageId: this.routeQueryForm.startAreaManageId,
          endAreaManageId: this.routeQueryForm.endAreaManageId,
          endStationId: this.routeQueryForm.endStationId,
          startCityName: this.routeQueryForm.startCityName,
          endCityName: this.routeQueryForm.endCityName,
          lineName: this.routeQueryForm.routeName,
          startStationId: this.routeQueryForm.startStationId,
          status: this.routeQueryForm.status,
          type: this.routeQueryForm.routeTypeId
        }
        // console.log('查询参数是：', linePageDto)
        this.loading = true
        getRoteList(linePageDto).then((res) => {
          if (res.code === 0) {
            this.routeDataTable = res.data.records
            this.countRoutePages = res.data.total
            this.currentPage = page
            this.loading = false
          }
          this.loading = false
        })
      },
      // 编辑线路
      editRoute(url, row) {
        setStore({ name: 'routerSetParams', content: this.routeQueryForm, type: 'session' })
        this.$router.push({ path: url, query: { id: row.id } })
      },
      // 上下架线路
      checkRouteStatus(row) {
        if (row.status === 1) {
          this.$confirm('确认要下架这条线路吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '稍后再看',
            type: 'warning'
          }).then(() => {
            const lineId = row.id
            const status = 2
            changeRouteStatus(lineId, status).then(() => {
              this.$message.success('下架成功')
              this.getRoteListPage()
            })
          })
        }
        if (row.status === 2) {
          this.$confirm('确认要上架这条线路吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '稍后再看',
            type: 'warning'
          }).then(() => {
            const lineId = row.id
            const status = 1
            changeRouteStatus(lineId, status).then(() => {
              this.$message.success('上架成功')
              this.getRoteListPage()
            })
          })
        }
      },
      // 重置表单查询数据
      clearRouteForm() {
        // this.$ref['routeQueryForm'] .resetFields()
        this.currentPage = 1
        this.eachPage = 10
        this.routeQueryForm = {}
        this.startAreaManageName = ''
        this.endAreaManageName = ''
        removeStore({ name: 'routerSetParams', type: 'session' })
        this.getRoteListPage()
      },
      // 获取所有的业务城市
      getAllCity() {
        queryAllCity().then((res) => {
          this.startCityNameList = res.data
          this.endCityNameList = res.data
        })
      },

      // 获取所有的站点
      getAllStation() {
        queryAllFstation().then((res) => {
          if (!Array.isArray(res.data)) {
            return
          }
          res.data.forEach((it) => {
            it.label = it.stationName
            it.value = it.id
          })
          this.startStationNameList = res.data
          this.endStationNameList = res.data
        })
      },
      // 打开线路详情
      getRouteInfo(row) {
        this.showDrawerVisible = true
        this.$nextTick(() => {
          this.$refs.routeSetInfo.init(row)
        })
      },
      // 处理当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getRoteListPage()
      },
      // 处理每页显示的条数
      handleSizeChange(val) {
        this.eachPage = val
        this.getRoteListPage()
      },
      // 路由跳转
      jumpUrl(url) {
        setStore({ name: 'routerSetParams', content: this.routeQueryForm, type: 'session' })
        this.$router.push({ path: url })
      },

      // 重置出发城市地级归属搜索条件
      resetStartAreaManager() {
        this.startAreaManageName = ''
        this.routeQueryForm.startAreaManageId = null
      },

      resetEndAreaManager() {
        this.endAreaManageName = ''
        this.routeQueryForm.endAreaManageId = null
      },

      filterRegionTreeNode(value, data) {
        if (!value) return true
        return data.areaName.indexOf(value) !== -1
      },

      filterEndRegionTreeNode(value, data) {
        if (!value) return true
        return data.areaName.indexOf(value) !== -1
      },

      // 点击节点事件
      handleNodeClick(data) {
        // console.log('点击的data是：', data)
        this.routeQueryForm.startAreaManageId = data.id
        this.startAreaManageName = data.areaName
        // this.areaManageName = data.areaName
      },

      handleEndNodeClick(data) {
        // console.log('点击的data是：', data)
        this.routeQueryForm.endAreaManageId = data.id
        this.endAreaManageName = data.areaName
      },

      filterRegionData(val) {
        this.startAreaManageName = val
      },

      filterEndRegionData(val) {
        this.endAreaManageName = val
      },

      // 获取所有的地级归属
      getAllAddressBelong() {
        getRegionTree().then(({ code, data }) => {
          if (code === 0) {
            this.startAreaTreeData = data
            this.endAreaTreeData = data
          }
        })
      },
      handleOperateLog() {
        this.operateVisible = true
      },
      handleClose() {
        this.operateVisible = false
      }
    }
  }
</script>

<style>
  .add-button {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  .route-pagination {
    margin-left: 65%;
  }
</style>
